import Sidebar from 'erpcore/components/Layout/Sidebar';
import MainNavigation from 'erpcore/components/Layout/MainNavigation';
import Main from 'erpcore/components/Layout/Main';

const defaultLayout = {
    data: [
        {
            slotName: 'leftSidebar',
            component: Sidebar,
            position: 0,
            content: {
                data: [
                    {
                        slotName: 'mainNavigation',
                        component: MainNavigation,
                        position: 1
                    }
                ]
            }
        },
        {
            slotName: 'main',
            component: Main,
            position: 0
        }
    ]
};

export default defaultLayout;
